// High Contrast plugin:
// Initiate plugin on the high contrast button
//Toggles high contrast mode and sets cookie
$.fn.highContrast = function(){
  var highContrast;

  //Set and delete a cookie (pass 0 for exdays to delete)
  function setCookie(cname,cvalue,exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = 'expires=' + d.toGMTString();
    var path = ';path=' + '/';
    //console.log(path);
    document.cookie = cname+'='+cvalue+'; '+expires + path;
  }

  //Get a cookie value
  function getCookie(cname) {
    var name = cname + '=';
    var ca = document.cookie.split(';');
    for(var i=0; i<ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0)===' ') {
         c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length,c.length);
      }
    }
    return '';
  }

  //Enable High Contast mode
  function setHighContrast(){
    highContrast = true;
    $('html').addClass('high-contrast');
  }

  //Disable High Contast mode
  function unsetHighContrast(){
    highContrast = false;
    $('html').removeClass('high-contrast');
    // $('html *').removeClass('set-contrast');
  }

  return this.each(function() {
    $(this).on('click', function(e){
      if (highContrast) {
        setCookie('highcontrast', '', 0);
        unsetHighContrast();
      }else{
        setCookie('highcontrast', '1', 'Session');
        setHighContrast();
      }

      e.preventDefault();
      e.stopPropagation();
      return false;
    });

    if (getCookie('highcontrast') === '1') {
      setHighContrast();
    }
  });
};

